module.exports = __webpack_public_path__ + "img/BigscreenTitle.de1b44a7.png";